export default function useDiscountPrice(price, discount) {
    var _discount_amount;
    let discountedPrice = price;
    if (price !== undefined && (discount === null || discount === void 0 ? void 0 : (_discount_amount = discount.amount) === null || _discount_amount === void 0 ? void 0 : _discount_amount.usd)) {
        var _discount_amount1;
        discountedPrice = price - (discount === null || discount === void 0 ? void 0 : (_discount_amount1 = discount.amount) === null || _discount_amount1 === void 0 ? void 0 : _discount_amount1.usd);
    }
    return {
        price,
        discountedPrice
    };
}

//# sourceMappingURL=useDiscountPrice.js.map